import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/evgBiz',
  component: layout,
  meta: {
    funcID: 'E0005',
    PID: 'E00',
  },
  children: ((pre) => [
    {
      path: 'evgExpense',
      name: `${pre}evgExpense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000501',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgBiz/evgExpense'),
    },
    {
      path: 'evgExpense/:pageType/:code?',
      name: `${pre}evgExpense-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { evgExpenseNo = '' } = $route.query || {}
          if (!evgExpenseNo) return 'EVG费用填报 | New'
          return `EVG费用填报 | ${evgExpenseNo}`
        },
        funcID: 'E000501',
        PID: 'E00',
        pageConfig: { layout: { class: 'p-0', bodyClass: 'p-0 m-0' } },
      },
      component: () => import('@/views/ecom/evgBiz/evgExpense/detail'),
    },
    {
      path: 'evgOnlineOrder',
      name: `${pre}evgOnlineOrder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000502',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgBiz/evgOnlineOrder'),
    },
    {
      path: 'evgLcInv',
      name: `${pre}evgLcInv`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000503',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgBiz/evgLcInv'),
    },
    {
      path: 'evgPackagingScheme',
      name: `${pre}evgPackagingScheme`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000504',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgBiz/evgPackagingScheme'),
    },
    {
      path: 'evgPackagingScheme/:pageType/:code?',
      name: `${pre}evgPackagingScheme-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { evgPackingSchemeNo = '' } = $route.query || {}
          if (!evgPackingSchemeNo) return '大货包装方案 | New'
          return `大货包装方案 | ${evgPackingSchemeNo}`
        },
        funcID: 'E000504',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'p-0 bg-transparent', bodyClass: 'p-0 m-0' },
        },
      },
      component: () => import('@/views/ecom/evgBiz/evgPackagingScheme/detail'),
    },
    {
      path: 'evgPlanOrder',
      name: `${pre}evgPlanOrder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000505',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgBiz/evgPlanOrder'),
    },
    {
      path: 'evgPlanOrder/:pageType/:code?',
      name: `${pre}evgPlanOrder-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { evgPlanOrderNo = '' } = $route.query || {}
          if (!evgPlanOrderNo) return '客户备货计划 | New'
          return `客户备货计划 | ${evgPlanOrderNo}`
        },
        funcID: 'E000505',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'p-0 bg-transparent', bodyClass: 'p-0 m-0' },
        },
      },
      component: () => import('@/views/ecom/evgBiz/evgPlanOrder/detail'),
    },
    {
      path: 'evgBulkOrder',
      name: `${pre}evgBulkOrder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000506',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgBiz/evgBulkOrder'),
    },
    {
      path: 'evgBulkOrder/:pageType/:evgBulkOrderCode?',
      name: `${pre}evgBulkOrder-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { evgBulkOrderNo = '' } = $route.query || {}
          return `客户大货订单 | ${evgBulkOrderNo || 'New'}`
        },
        funcID: 'E000506',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'p-0 bg-transparent', bodyClass: 'p-0 m-0' },
        },
      },
      component: () => import('@/views/ecom/evgBiz/evgBulkOrder/detail'),
    },
    {
      path: 'evgPrePurchaseOrder',
      name: `${pre}evgPrePurchaseOrder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000507',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgBiz/evgPrePurchaseOrder'),
    },
    {
      path: 'evgPurchaseOrder',
      name: `${pre}evgPurchaseOrder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000508',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgBiz/evgPurchaseOrder'),
    },
    {
      path: 'evgPurchaseOrder/:pageType/:evgPurchaseCode?',
      name: `${pre}evgPurchaseOrder-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { evgPurchaseNo = '' } = $route.query || {}
          return `工厂采购订单 | ${evgPurchaseNo || 'New'}`
        },
        funcID: 'E000508',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'p-0 bg-transparent', bodyClass: 'p-0 m-0' },
        },
      },
      component: () => import('@/views/ecom/evgBiz/evgPurchaseOrder/detail'),
    },
    {
      path: 'evgBulkOrderBackRequest',
      name: `${pre}evgBulkOrderBackRequest`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000509',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgBiz/evgBulkOrderBackRequest'),
    },
  ])('ecom-evgBiz-'),
}
